import { useTheme } from "arkh";
import React, { useEffect, useMemo, useState } from "react";

import { Image, View } from "react-native";

import { useWidgetLayout } from "../WidgetLayoutContext";
import { graphql, useFragment } from "react-relay";

import { WidgetNotePageBackground_widgetNotePage$key } from "./__generated__/WidgetNotePageBackground_widgetNotePage.graphql";

export function WidgetNotePageBackground(props: {
  page: WidgetNotePageBackground_widgetNotePage$key;
}) {
  const { unitSize, height, width } = useWidgetLayout();

  const page = useFragment(
    graphql`
      fragment WidgetNotePageBackground_widgetNotePage on WidgetNotePage {
        backgroundColor
        image {
          id
          largeImage: size(minHeight: 1080, minWidth: 1080) {
            url
            height
            width
          }
        }
        imageScale
        imageTranslateX
        imageTranslateY
      }
    `,
    props.page
  );

  const [imageDimensions, setImageDimensions] = useState({
    width: page.image?.largeImage?.width || 1,
    height: page.image?.largeImage?.height || 1,
  });

  const scaleFactor = useMemo(() => {
    if (!page?.image?.largeImage) {
      return 1;
    }
    return width / height > imageDimensions.width / imageDimensions.height
      ? width / imageDimensions.width
      : height / imageDimensions.height;
  }, [
    height,
    imageDimensions.height,
    imageDimensions.width,
    page?.image?.largeImage,
    width,
  ]);

  useEffect(() => {
    if (page.image?.largeImage?.url) {
      Image.getSize(
        page.image?.largeImage?.url,
        (width, height) => {
          setImageDimensions({ width, height });
        },
        (error) => {
          console.log("err", error);
        }
      );
    }
  }, [page.image?.largeImage?.url]);

  const theme = useTheme();

  if (!page.image?.largeImage?.url) {
    return (
      <View
        style={{
          height: "100%",
          width: "100%",
          position: "absolute",
          backgroundColor: page.backgroundColor ?? theme.surface,
        }}
      />
    );
  }
  return (
    <Image
      source={{ uri: page.image.largeImage.url }}
      progressiveRenderingEnabled
      resizeMode="cover"
      style={{
        position: "absolute",
        width: imageDimensions.width * scaleFactor ?? 1,
        height: imageDimensions.height * scaleFactor ?? 1,
        alignSelf: "center",
        transform: [
          {
            translateX: (page.imageTranslateX ?? 0) * unitSize,
          },
          {
            translateY: (page.imageTranslateY ?? 0) * unitSize,
          },
          {
            scale: page.imageScale ?? 1,
          },
        ],
      }}
    />
  );
}
